import React from 'react';

import './style.sass';

const CommonTitle = ({ children, className = '' }) => {
    return <h2 className={`common__title ${className}`}>{children}</h2>;
};

export default CommonTitle;
